import React from 'react'
import {observer} from 'mobx-react-lite'
import {GridApi} from 'ag-grid-community'
import {SearchIcon} from '@oc/icons'
import {messages} from '../translations'
import {makeStyles} from '@oc/styles'
import {TextField} from '@mui/material'

const useStyles = makeStyles(theme => ({
    paddingRight8: {
        paddingRight: theme.spacing(1)
    },
    searchField: {
        width: 220
    }
}))

interface AgGridQuickSearchProps {
    gridApi: GridApi | undefined | null
}

function _AgGridQuickSearch(props: AgGridQuickSearchProps) {
    const {classes} = useStyles()

    const onSearchChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            props.gridApi?.setGridOption('quickFilterText', e.target.value)
        },
        [props.gridApi]
    )

    return (
        <TextField
            placeholder={messages.getText('misc', 'search')}
            className={classes.searchField}
            onChange={onSearchChange}
            InputProps={{
                startAdornment: <SearchIcon size="24px" className={classes.paddingRight8} />
            }}
        />
    )
}
export const AgGridQuickSearch = observer(_AgGridQuickSearch)
